import { render } from "./CreateNewItems.vue?vue&type=template&id=b1b35b04"
import script from "./CreateNewItems.vue?vue&type=script&lang=ts"
export * from "./CreateNewItems.vue?vue&type=script&lang=ts"
script.render = render

export default script